function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "movies");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "movies",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(2.000000, 0.000000)"
}, React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0.982142857,
  width: 20,
  height: 18.5714286
}), React.createElement("g", {
  id: "Group-17",
  transform: "translate(0.000000, -0.000000)"
}, React.createElement("path", {
  d: "M2.4914637,8.52678571 C1.11224366,8.1180399 0.11438658,6.92790675 0.11438658,5.5234126 C0.11438658,3.7810599 1.65006619,2.36860396 3.544423,2.36860396 C4.78204012,2.36860396 5.86656513,2.97147437 6.46978869,3.8753415 C6.71141754,1.69789349 8.68223212,2.39808173e-14 11.0776748,2.39808173e-14 C13.6362891,2.39808173e-14 15.7104558,1.93708433 15.7104558,4.32659895 C15.7104558,6.35671373 14.2133053,8.06026062 12.1938886,8.52678571 L13,8.52678571 C14.1045695,8.52678571 15,9.42221621 15,10.5267857 L15,10.8503449 L18.4289722,8.46520047 C18.8823598,8.14983055 19.5055608,8.26171592 19.8209307,8.71510345 C19.9375113,8.88270403 20,9.081972 20,9.28613122 L20,15.8924875 C20,16.4447722 19.5522847,16.8924875 19,16.8924875 C18.7958408,16.8924875 18.5965728,16.8299988 18.4289722,16.7134182 L15,14.3282738 L15,15.8125 C15,16.9170695 14.1045695,17.8125 13,17.8125 L2,17.8125 C0.8954305,17.8125 1.11632554e-15,16.9170695 0,15.8125 L0,10.5267857 C-1.3527075e-16,9.42221621 0.8954305,8.52678571 2,8.52678571 L2.4914637,8.52678571 Z M4.5973823,8.52678571 L9.96146095,8.52678571 C8.60694594,8.21386602 7.48739835,7.3444105 6.89700742,6.19316531 C6.63768808,7.29646998 5.75091944,8.18492331 4.5973823,8.52678571 Z M15.7104558,11.6781345 L15.7104558,13.4059118 L18.8541667,15.7420276 L18.8541667,9.55357143 L15.7104558,11.6781345 Z M11.0776748,7.36407585 C12.8739429,7.36407585 14.330106,6.00415112 14.330106,4.32659895 C14.330106,2.64904678 12.8739429,1.28912205 11.0776748,1.28912205 C9.28140665,1.28912205 7.82524362,2.64904678 7.82524362,4.32659895 C7.82524362,6.00415112 9.28140665,7.36407585 11.0776748,7.36407585 Z M3.544423,7.34849894 C4.64032614,7.34849894 5.52873118,6.53137995 5.52873118,5.5234126 C5.52873118,4.51544525 4.64032614,3.69832627 3.544423,3.69832627 C2.44851985,3.69832627 1.56011482,4.51544525 1.56011482,5.5234126 C1.56011482,6.53137995 2.44851985,7.34849894 3.544423,7.34849894 Z",
  id: "Combined-Shape",
  fill: "#D0021B"
}), React.createElement("g", {
  id: "Group-15",
  transform: "translate(0.010742, 0.000000)"
}))));

var SvgMoviesNew = function SvgMoviesNew(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoviesNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/movies_new.d7d8ce2a.svg";
export { ForwardRef as ReactComponent };